
export class PlanGoodsCoopModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * Ｐコード会員生協
   */
  // 生協コード
  public coopCode: string = <string>'';

  // 取扱会員生協区分
  public dealCoopDiv: string = <string>'';

  // システムマーク１
  public systemMark1: string = <string>'';

  // システムマーク２
  public systemMark2: string = <string>'';

  // システムマーク３
  public systemMark3: string = <string>'';

  // システムマーク４
  public systemMark4: string = <string>'';

  // システムマーク５
  public systemMark5: string = <string>'';

  // アイテムコード
  public itemCode: string = <string>'';

  // 価格パターン
  public pricePatern: string = <string>'';

  // 今回供給価格
  public thisTimeSupplyPrice: string = <string>'';

  // 今回仕入価格
  public thisTimeCostPrice: string = <string>'';

  /**
   * Ｐコード詳細情報
   */
  // ブランド区分
  public brandType: string = <string>'';

  // セット区分
  public setDiv: string = <string>'';

  // 仕分温度帯区分
  public assortTempDiv: string = <string>'';

  // 注文コード割当コード
  public orderNumQuotaCode: string = <string>'';

  // 通常媒体取扱フラグ
  public detailUseRegularFlg: string = <string>'';

  // 産地コメント１
  public producingAreaComment1: string = <string>'';

  // 産地コメント２
  public producingAreaComment2: string = <string>'';

  /**
   * Ｐコード組合員の声
   */
  // 受付番号
  public receiptNum: string = <string>'';

  /**
   * Ｐコード計画数
   */
  // 計画数
  public planNum: string = <string>'';

  // 限定数量総数
  public limitNumTotal: string = <string>'';

  // 限定数量個人
  public limitNumPerson: string = <string>'';

  // 配達リード区分
  public deliveryLeadTimeType: string = <string>'';

  // 配達企画回
  public delivCatalogID: string = <string>'';

  /**
   * Ｐコード案内
   */
  // 登場区分
  public appearDiv: string = <string>'';

  // 次回案内
  public nextGuide: string = <string>'';

  // 取り扱い生協フラグ
  public useRegularFlg: number = null;
}
